import { MASS_EDIT_SEND_TYPE } from '@store/machines/massEdit';
import { TERMINATE_REASON } from '@store/machines/massEdit.schema';
import { ICloseItem } from '../components/CloseDialog';

export function getSavingItems(
  reason: TERMINATE_REASON,
  send: MASS_EDIT_SEND_TYPE,
): ICloseItem[] {
  return [
    {
      onClick() {
        send({
          type: 'FORCE-TERMINATE',
          reason,
        });
      },
      text: 'Exit anyways',
      status: 'ERROR',
    },
    {
      onClick() {
        send({ type: 'ABORT' });
      },
      text: 'Continue Editing',
    },
  ];
}
export function getPromptItems(
  reason: TERMINATE_REASON,
  send: MASS_EDIT_SEND_TYPE,
): ICloseItem[] {
  return [
    {
      onClick() {
        send({
          type: 'FORCE-TERMINATE',
          reason,
        });
      },
      text: 'Discard Changes',
      status: 'ERROR',
    },
    {
      onClick() {
        send({ type: 'ABORT' });
      },
      text: 'Continue Editing',
    },
    {
      onClick() {
        send({ type: 'SAVE-FIRST' });
      },
      text: 'Save then close',
    },
  ];
}
